import React, { useState } from 'react';
import { FaComments, FaTimes } from 'react-icons/fa'; // Import icons

const ChatBox = () => {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [isOpen, setIsOpen] = useState(false); // State to control chat box visibility

  // Handle sending a message
  const sendMessage = () => {
    if (message.trim()) {
      setMessages([...messages, { sender: 'You', text: message }]);
      setMessage('');
      // Optionally, you can add logic to handle receiving a message
      setTimeout(() => {
        setMessages(prevMessages => [
          ...prevMessages,
          { sender: 'Bot', text: 'Hello! How can I help you?' },
        ]);
      }, 1000);
    }
  };

  // Toggle chat box visibility
  const toggleChatBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      {/* Icon to toggle chat box */}
      <div onClick={toggleChatBox} style={styles.iconContainer}>
        {isOpen ? <FaTimes style={styles.icon} /> : <FaComments style={styles.icon} />}
      </div>

      {isOpen && (
        <div style={styles.chatContainer}>
          <div style={styles.chatWindow}>
            {messages.map((msg, index) => (
              <div key={index} style={msg.sender === 'You' ? styles.sentMessage : styles.receivedMessage}>
                <strong>{msg.sender}:</strong> {msg.text}
              </div>
            ))}
          </div>
          <div style={styles.inputContainer}>
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message..."
              style={styles.input}
            />
            <button onClick={sendMessage} style={styles.sendButton}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  iconContainer: {
    position: 'fixed',
    bottom: '60px',
    right: '12px',
    backgroundColor: 'rgb(236 115 34)',
    borderRadius: '50%',
    padding: '15px',
    cursor: 'pointer',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
    color:'#000'
  },
  icon: {
    fontSize: '24px',
    color: '#fff',
  },
  chatContainer: {
    width: '300px',
    height: '400px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    bottom: '60px',
    right: '65px',
    backgroundColor: '#fff',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    zIndex: 1000,
  },
  chatWindow: {
    flex: 1,
    overflowY: 'scroll',
    padding: '10px',
    borderBottom: '1px solid #ccc',
  },
  sentMessage: {
    textAlign: 'right',
    backgroundColor: '#f1f1f1',
    padding: '5px',
    margin: '5px 0',
    borderRadius: '5px',
  },
  receivedMessage: {
    textAlign: 'left',
    backgroundColor: '#e1f7d5',
    padding: '5px',
    margin: '5px 0',
    borderRadius: '5px',
  },
  inputContainer: {
    display: 'flex',
    padding: '10px',
  },
  input: {
    flex: 1,
    padding: '5px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  sendButton: {
    padding: '5px 10px',
    borderRadius: '5px',
    backgroundColor: '#4CAF50',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    marginLeft: '5px',
  },
};

export default ChatBox;
